<template>
  <div v-if="experience">
    <h4 class="mb-5">{{ student_name }}</h4>
    <vs-divider />
    <!-- PROFILE HEADER -->
    <div class="profile-header">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img :src="coverSrc" alt="" class="responsive block" />
        </div>
      </div>

      <breadcrumb class="mt-5" :breadcrumbs="breadcrumb" />

      <h4 class="pt-5">{{ experience.vje.name }}</h4>

      <div class="flex items-center justify-end flex-wrap profile-header-nav mt-5">
        <div class="block w-full flex-grow sm:flex sm:items-center sm:w-auto">
          <div class="text-sm sm:flex-grow">
            <ul class="custom-tab md:flex mt-8 w-full md:mt-0 md:ml-auto md:w-4/4 hidden">
              <li v-for="(item, ind) in tab_contents" v-if="!item.hidden" :key="`tab_${ind}`">
                <router-link :to="item.link">{{ item.name }}</router-link>
              </li>
            </ul>
            <select
              class="default-select tab-select block md:hidden"
              @change="onChange($event)"
              v-model="tab_value"
              aria-label="Select a section"
            >
              <option
                v-for="(item, ind) in tab_contents"
                v-if="!item.hidden"
                :key="`tab_${ind}`"
                :value="item.link"
              >
                {{ item.name }}
              </option>
            </select>
          </div>

          <!--          <div class="text-sm sm:flex-grow">-->
          <!--            <ul class="sm:flex justify-around mt-8 w-full md:mt-0 md:ml-auto md:w-4/4">-->
          <!--              <li class="p-2 sm:p-0" v-if="experience.type == 1"><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/activities'">Activities</router-link></li>-->
          <!--              <li class="p-2 sm:p-0" v-else><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/experience-info'">Experience Info</router-link></li>-->
          <!--              <li class="p-2 sm:p-0 hidden"><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/projects'">Projects</router-link></li>-->
          <!--              <li class="p-2 sm:p-0"><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/reflection'">Reflection</router-link></li>-->
          <!--              <li class="p-2 sm:p-0"><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/thankyou-letter'">Thank You Letter</router-link></li>-->
          <!--              <li class="p-2 sm:p-0"><router-link :to="'/teacher/vje/experience/view/' + this.$route.params.id + '/certificate'">Certificate</router-link></li>-->
          <!--            </ul>-->
          <!--          </div>-->
        </div>
      </div>
      <!-- <vx-navbar> -->
      <!-- </vx-navbar> -->
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <transition name="zoom-fade" mode="out-in">
          <router-view @activityLoaded="updateActivity" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import Breadcrumb from '../../../../components/UI/Breadcrumb';
export default {
  components: { Breadcrumb },
  data() {
    return {
      student_name: '',
      tab_value: this.$route.path,
      activity_title: null,
      loginType: localStorage.getItem('login_type'),
    };
  },
  watch: {
    '$route.name'(value) {
      if (value === 'teacher-we-activities') {
        this.activity_title = null;
      }
    },
  },
  computed: {
    breadcrumb() {
      const route_name = this.$route.name;
      let current_page = [];
      switch (route_name) {
        case 'teacher-we-experienceinfo':
          current_page = [
            {
              title: 'Experience Info',
              status: 'active',
            },
          ];
          break;
        case 'teacher-we-reflection':
          current_page = [
            {
              title: 'Reflection',
              status: 'active',
            },
          ];
          break;

        case 'teacher-we-activities':
          current_page = [
            {
              title: 'Activities',
              status: 'active',
            },
          ];
          break;

        case 'teacher-we-thankyouletter':
          current_page = [
            {
              title: 'Thank you letter',
              status: 'active',
            },
          ];
          break;

        case 'teacher-we-certificate':
          current_page = [
            {
              title: 'Certificate',
              status: 'active',
            },
          ];
          break;

        case 'activity-teacher':
          current_page = [
            {
              title: 'Activities',
              url: `/teacher/vje/experience/view/${this.$route.params.id}/activities`,
            },
            {
              title: this.activity_title,
              status: 'active',
            },
          ];
      }

      return [
        {
          title: 'Home',
          url: `/${this.loginType}/dashboard`,
        },
        {
          title: 'Student activities',
          url: `/teacher/vje/activity`,
        },
        {
          title: `${this.student_name}`,
          url: `/teacher/vje/activity/student/${this.experience.student_id}/`,
        },
        ...current_page,
      ];
    },
    experience() {
      return store.getters['authTeacher/experience'];
    },
    coverSrc() {
      return require('@/assets/images/experiences/' +
        this.experience.vje.folder_name.toLowerCase() +
        '/cover_photo.jpg');
    },
    tab_contents() {
      let tab_contents = [];

      if (this.experience.type === 1) {
        tab_contents = [
          {
            link: '/teacher/vje/experience/view/' + this.$route.params.id + '/activities',
            name: 'Activities',
          },
        ];
      } else {
        tab_contents.push({
          link: '/teacher/vje/experience/view/' + this.$route.params.id + '/experience-info',
          name: 'Experience Info',
        });
      }

      tab_contents.push(
        {
          link: '/teacher/vje/experience/view/' + this.$route.params.id + '/projects',
          name: 'Projects',
          hidden: true,
        },
        {
          link: '/teacher/vje/experience/view/' + this.$route.params.id + '/reflection',
          name: 'Reflection',
        },
        {
          link: '/teacher/vje/experience/view/' + this.$route.params.id + '/thankyou-letter',
          name: 'Thank you Letter',
          hidden: this.experience.type === 1,
        },
        {
          link: '/teacher/vje/experience/view/' + this.$route.params.id + '/certificate',
          name: 'Certificate',
        },
      );

      return tab_contents;
    },
  },
  beforeMount() {
    this.loadExperience();
  },
  methods: {
    async loadExperience() {
      theApi.methods
        .makeCall(false, 'vje_students/experience/' + this.$route.params.id, 'get')
        .then(
          (data) => {
            this.student_name = data.student_name;
            store.commit('authTeacher/setExperience', data.experience);
          },
          () => {},
        );
    },

    updateActivity(activity) {
      this.activity_title = activity;
    },
  },
};
</script>
